/* Dev Theme Dan – Sammel-Fixes (JS). Versteckte Videos (Desktop-/Handy-Duplikate) laden nicht mehr mit,
   Autoplay-Videos ausserhalb des Bildschirms starten erst beim Hinscrollen (z. B. LUSH Party). */
(function () {
  var isHidden = function (v) { return !v.getClientRects().length || (!v.offsetWidth && !v.offsetHeight); };
  var off = function (v) {
    if (v.dataset.dfOff) return;
    v.dataset.dfOff = '1';
    v.autoplay = false; v.removeAttribute('autoplay'); v.preload = 'none';
    try { v.pause(); } catch (e) {}
    v.querySelectorAll('source[src]').forEach(function (s) { s.dataset.dfSrc = s.getAttribute('src'); s.removeAttribute('src'); });
    if (v.getAttribute('src')) { v.dataset.dfSrc = v.getAttribute('src'); v.removeAttribute('src'); }
    try { v.load(); } catch (e) {}
  };
  var on = function (v) {
    if (!v.dataset.dfOff) return;
    delete v.dataset.dfOff;
    v.querySelectorAll('source[data-df-src]').forEach(function (s) { s.setAttribute('src', s.dataset.dfSrc); });
    if (v.dataset.dfSrc) v.setAttribute('src', v.dataset.dfSrc);
    v.preload = 'metadata';
    try { v.load(); } catch (e) {}
    if (v.dataset.dfAuto) { v.autoplay = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  };
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting && !isHidden(v)) { v.dataset.dfSeen = '1'; on(v); }
    });
  }, { rootMargin: '300px 0px' }) : null;
  var run = function () {
    document.querySelectorAll('video').forEach(function (v) {
      if (v.autoplay || v.hasAttribute('autoplay')) v.dataset.dfAuto = '1';
      if (isHidden(v)) { off(v); return; }
      if (io) {
        var r = v.getBoundingClientRect();
        var near = r.top < window.innerHeight + 300 && r.bottom > -300;
        if (!near && v.dataset.dfAuto && !v.dataset.dfSeen) off(v);
        else if (near) { v.dataset.dfSeen = '1'; on(v); }
        if (!v.dataset.dfObs) { v.dataset.dfObs = '1'; io.observe(v); }
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(run, 300); });
  var st; window.addEventListener('scroll', function () { if (st) return; st = setTimeout(function () { st = null; run(); }, 250); }, { passive: true });
})();

/* Story-Slider auf dem Handy: Flickity-Ziehen abfangen, damit das native Wischen (CSS in dev-fixes.css) funktioniert (Dan, 06.10.) */
(function () {
  var mq = window.matchMedia('(max-width: 798px)');
  var stop = function (e) { if (mq.matches && e.target.closest && e.target.closest('.flickity-viewport')) e.stopPropagation(); };
  var bind = function () {
    document.querySelectorAll('.blog-posts').forEach(function (s) {
      if (s.dataset.dfSwipe) return;
      s.dataset.dfSwipe = '1';
      ['pointerdown', 'touchstart', 'mousedown'].forEach(function (t) { s.addEventListener(t, stop, true); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('shopify:section:load', bind);
})();

/* Produktseite Handy: Menge + "In den Warenkorb" bleiben unten fixiert, sobald man am normalen Kaufbereich vorbeigescrollt ist (Dan, 06.10.) */
(function () {
  if (!document.body || !document.body.classList.contains('product')) return;
  var mq = window.matchMedia('(max-width: 798px)');
  var pd = document.querySelector('.product_section form.shopify-product-form .purchase-details');
  if (!pd || pd.dataset.dfSticky) return;
  pd.dataset.dfSticky = '1';
  var P = 'html:not(#dfx) body.product ';
  var css =
    /* Handy: fixierte Leiste unten */
    '@media (max-width: 798px) {' +
    P + '.purchase-details.df-sticky { position: fixed !important; left: 0 !important; right: 0 !important; bottom: 0 !important; z-index: 48; width: auto !important; max-width: none !important; margin: 0 !important; box-sizing: border-box; background: #fff; padding: 10px 16px calc(10px + env(safe-area-inset-bottom)) !important; box-shadow: 0 -6px 20px rgba(0,0,0,.08); flex-wrap: nowrap !important; }' +
    P + '.purchase-details.df-sticky > :not(.purchase-details__quantity):not(.purchase-details__buttons) { display: none !important; }' +
    'html.df-has-sticky:not(#dfx) body { padding-bottom: 80px; }' +
    '}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);
  var ph = document.createElement('div');
  ph.className = 'df-sticky-ph';
  pd.parentNode.insertBefore(ph, pd);
  ph.appendChild(pd);
  var upd = function () {
    var root = document.documentElement;
    if (!mq.matches) { pd.classList.remove('df-sticky'); ph.style.minHeight = ''; root.classList.remove('df-has-sticky'); return; }
    var r = ph.getBoundingClientRect();
    var stick = r.bottom < 0; /* erst fixieren, wenn man am normalen Kaufbereich vorbeigescrollt ist */
    var end = document.querySelector('.vb') || document.querySelector('footer');
    if (stick && end && end.getBoundingClientRect().top < window.innerHeight) stick = false; /* ab der Werte-Leiste / dem Footer wieder weg */
    if (stick && !pd.classList.contains('df-sticky')) { ph.style.minHeight = pd.offsetHeight + 'px'; pd.classList.add('df-sticky'); }
    else if (!stick && pd.classList.contains('df-sticky')) { pd.classList.remove('df-sticky'); ph.style.minHeight = ''; }
    root.classList.toggle('df-has-sticky', stick);
  };
  var tick = false;
  var onScroll = function () { if (tick) return; tick = true; setTimeout(function () { tick = false; upd(); }, 60); };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  upd();
  window.addEventListener('load', upd);
})();

/* Footer Handy: Newsletter mit sauberem, einheitlichem Rand (20px) und Abständen; Menüs als aufklappbare Dropdowns (Dan, 06.10.) */
(function () {
  var mq = window.matchMedia('(max-width: 798px)');
  /* Newsletter-Look (Handy-Version) auf allen Bildschirmgrössen: Titel, Text, Felder und Button mit gleichen Abständen */
  var nl = 'html:not(#dfx) body footer .block__newsletter ';
  var css = nl + '.footer__heading { margin: 0 0 12px !important; }' +
    nl + '.content { margin: 0 0 20px !important; }' + nl + '.content p { margin: 0 !important; }' +
    nl + '.newsletter-form .field { margin: 0 0 12px !important; }' +
    nl + '.newsletter-form .field:last-child { margin: 4px 0 0 !important; }' +
    nl + '.newsletter-form :is(input[type=text], input[type=email]) { height: 52px !important; box-sizing: border-box; }' +
    nl + '.newsletter-form :is(button, input[type=submit]) { height: 52px !important; min-height: 0 !important; }' +
    '@media (max-width: 798px) {' +
    'html:not(#dfx) body footer .footer__content > .container { padding-left: 20px !important; padding-right: 20px !important; }' +
    'html:not(#dfx) body footer .footer__content .footer__block { width: 100% !important; max-width: none !important; min-width: 0 !important; flex-basis: 100% !important; margin-left: 0 !important; margin-right: 0 !important; padding-left: 0 !important; padding-right: 0 !important; box-sizing: border-box; }' +
    'html:not(#dfx) body footer .block__newsletter { padding-top: 8px !important; padding-bottom: 0 !important; margin: 0 0 32px !important; }' +
    nl + '.content p { max-width: none !important; width: auto !important; }' +
    nl + '.newsletter-form .field, ' + nl + '.newsletter-form :is(input[type=text], input[type=email], button, input[type=submit]) { width: 100% !important; max-width: none !important; }' +
    'html:not(#dfx) body footer .block__newsletter .newsletter-form__wrapper, html:not(#dfx) body footer .block__newsletter form, html:not(#dfx) body footer .block__newsletter .newsletter-form, html:not(#dfx) body footer .block__newsletter .newsletter-form .control { width: 100% !important; max-width: none !important; min-width: 0 !important; }' +
    'html:not(#dfx) body footer .block__link-list { padding: 0 !important; margin: 0 !important; border-top: 1px solid rgba(255,255,255,.2); }' +
    'html:not(#dfx) body footer .block__link-list:not(:has(~ .block__link-list)) { border-bottom: 1px solid rgba(255,255,255,.2); margin-bottom: 24px !important; }' +
    'html:not(#dfx) body footer .df-acc { width: 100% !important; }' +
    'html:not(#dfx) body footer .df-acc .footer__heading { display: flex !important; justify-content: space-between; align-items: center; cursor: pointer; margin: 0 !important; padding: 16px 0 !important; -webkit-tap-highlight-color: transparent; }' +
    'html:not(#dfx) body footer .df-acc .footer__heading::after { content: ""; width: 8px; height: 8px; border-right: 2px solid currentColor; border-bottom: 2px solid currentColor; transform: rotate(45deg); margin: -5px 4px 0 12px; transition: transform .2s; flex: 0 0 auto; }' +
    'html:not(#dfx) body footer .df-acc.is-open .footer__heading::after { transform: rotate(-135deg); margin-top: 5px; }' +
    'html:not(#dfx) body footer .df-acc:not(.is-open) > ul { display: none !important; }' +
    'html:not(#dfx) body footer .df-acc > ul { margin: 0 !important; padding: 0 0 16px !important; }' +
    '}';
  var init = function () {
    var menus = document.querySelectorAll('footer .block__link-list .footer__menu');
    if (!menus.length) return;
    if (!document.getElementById('df-footer-css')) {
      var st = document.createElement('style'); st.id = 'df-footer-css'; st.textContent = css; document.head.appendChild(st);
    }
    menus.forEach(function (m) {
      if (m.dataset.dfAcc) return;
      var h = m.querySelector('.footer__heading'); var ul = m.querySelector('ul');
      if (!h || !ul) return;
      m.dataset.dfAcc = '1';
      m.classList.add('df-acc');
      h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0'); h.setAttribute('aria-expanded', 'false');
      var toggle = function (e) {
        if (!mq.matches) return;
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        var open = m.classList.toggle('is-open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', toggle);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Kollektionen: geöffnete Sortierung ("Relevanz") liegt über den Wunschliste-Herzen der Kacheln (Dan, 06.10.) */
(function () {
  var st = document.createElement('style');
  st.textContent = 'html:not(#dfx) body .toolbar-sorting-button { position: relative; z-index: 30 !important; }' +
    'html:not(#dfx) body .toolbar-sorting-list { z-index: 30 !important; }';
  document.head.appendChild(st);
})();

/* Handy: nach "In den Warenkorb" springt das Theme per Animation zum Warenkorb-Symbol oben (und das bei jeder weiteren
   Button-Animation erneut) – das störte das Scrollen. Diesen Sprung zum Header-Warenkorb unterbinden (Dan, 06.10.) */
(function () {
  var patch = function () {
    var T = window.PXUTheme;
    if (!T || typeof T.scrollToTop !== 'function') return false;
    if (T.scrollToTop.dfPatched) return true;
    var orig = T.scrollToTop;
    var wrapped = function (el) {
      try {
        var node = el && (el.jquery ? el[0] : (typeof el === 'string' ? document.querySelector(el) : el));
        if (node && node.closest && node.closest('.mobile-header') && node.matches('[data-ajax-cart-trigger]')) return;
      } catch (e) {}
      return orig.apply(this, arguments);
    };
    wrapped.dfPatched = true;
    T.scrollToTop = wrapped;
    return true;
  };
  if (!patch()) {
    var n = 0;
    var iv = setInterval(function () { if (patch() || ++n > 50) clearInterval(iv); }, 200);
  }
})();

/* "In den Warenkorb": statt Popup wird der geklickte Button kurz grün mit "Hinzugefügt" (Produktseite und Kacheln, Dan, 06.10.)
   Kollektionsseiten (Kacheln der Filter-App, Dan 16.10.):
   - Produkt ohne Varianten: die App zeigt nach dem Hinzufügen den Plus/Minus-Zähler – dieser leuchtet kurz grün auf
   - Produkt mit Varianten: kein Zähler, der Button wird nach der Variantenwahl kurz grün mit "Hinzugefügt"
   - In beiden Fällen bleibt der Button während "Wird hinzugefügt…" gleich breit (Handy, Dan 16.10.) */
(function () {
  var lang = (document.documentElement.lang || 'de').slice(0, 2);
  var L = { de: 'Hinzugefügt', fr: 'Ajouté', it: 'Aggiunto' }[lang] || 'Hinzugefügt';
  var st = document.createElement('style');
  st.textContent = '[data-cart-add-confirmation] { display: none !important; }' +
    'html:not(#dfx) body .df-added { background: #247D36 !important; border-color: #247D36 !important; color: #fff !important; }' +
    'html:not(#dfx) body .df-added * { color: #fff !important; }' +
    'html:not(#dfx) body .df-added:not(.product-card-quantity) span { animation: none !important; opacity: 1 !important; transform: none !important; visibility: visible !important; }' +
    'html:not(#dfx) body .df-added:not(.product-card-quantity) svg, html:not(#dfx) body .df-added .checkmark { display: none !important; }' +
    /* Plus/Minus-Zähler: grün aufleuchten und sanft zurück */
    'html:not(#dfx) body .product-card-quantity { transition: background-color .4s ease, border-color .4s ease, color .4s ease; }' +
    'html:not(#dfx) body .product-card-quantity.df-added { transition: none; }' +
    /* Kachel-Buttons behalten ihre ursprüngliche Breite (wird beim Klick fixiert), längere Texte werden gekürzt statt den Button zu verbreitern */
    'html:not(#dfx) body .product-card-add-to-bag.df-lock { justify-content: center !important; overflow: hidden; box-sizing: border-box !important; }' +
    'html:not(#dfx) body .product-card-add-to-bag.df-lock span { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0; }';
  document.head.appendChild(st);
  var last = null, lastT = 0;
  /* Textfeld des Buttons: Produktseite span.text, Startseiten-Kacheln .pc-btn-text, Kollektions-Kacheln .api-product-button-text */
  var label = function (b) { return b.querySelector('.api-product-button-text, .api-button-text, .pc-btn-text, span.text') || b.querySelector('span:last-of-type'); };
  /* Kollektions-Kachel: sichtbarer Button (Desktop- oder Handy-Variante) und ob das Produkt nur eine Variante hat */
  var apiButton = function (ac) {
    var l = ac.querySelectorAll('.product-card-add-to-bag');
    for (var i = 0; i < l.length; i++) { if (l[i].offsetParent) return l[i]; }
    return l[0] || null;
  };
  var apiSingle = function (ac) {
    var A = window.PXUTheme && window.PXUTheme.jsApiCollection;
    var p = A && A.products && A.products.get && A.products.get(String(ac.getAttribute('data-product-id')));
    return !!(p && p.variants && p.variants.length === 1);
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.button--add-to-cart:not(.ajax-cart__button), .product-card-add-to-bag, .product-card-variant');
    if (!b) return;
    var ac = b.closest('.api-product-card');
    var single = false;
    if (ac) {
      /* Variante im Popup gewählt → der Button der Kachel wird grün, nicht der Listeneintrag */
      if (b.classList.contains('product-card-variant')) b = apiButton(ac) || b;
      single = apiSingle(ac);
      b.dfSingleCard = single ? ac : null;
    } else if (b.classList.contains('product-card-variant')) { var card = b.closest('.product-card'); b = (card && card.querySelector('.product-card-add-to-bag')) || b; }
    if (!single) {
      var sp = label(b);
      if (sp && !b.classList.contains('df-added')) b.dfOrig = sp.textContent;
      last = b; lastT = Date.now();
    }
    if (b.classList.contains('product-card-add-to-bag') && !b.classList.contains('df-lock') && b.offsetWidth) {
      /* Breite festhalten, damit der Button beim Textwechsel ("Wird hinzugefügt…") nicht wächst */
      b.style.width = b.offsetWidth + 'px';
      b.classList.add('df-lock');
      clearTimeout(b.dfUnlock);
      b.dfUnlock = setTimeout(function () { unlock(b); }, 8000);
    }
    if (ac) watchApi(b);
  }, true);
  var unlock = function (b) { if (b.classList.contains('df-added')) return; b.classList.remove('df-lock'); b.style.width = ''; };
  /* Erfolgreiches Hinzufügen der Kollektions-Kacheln am Antwort von /cart/add erkennen */
  var pendingApi = null, pendingT = 0;
  if (window.fetch && !window.fetch.dfWrapped) {
    var of = window.fetch;
    var wf = function (u) {
      var p = of.apply(this, arguments);
      try {
        var url = String((u && u.url) || u);
        if (/\/cart\/add/.test(url) && pendingApi && Date.now() - pendingT < 8000) {
          var b = pendingApi;
          p.then(function (r) {
            if (!(r && r.ok && pendingApi === b)) return;
            pendingApi = null;
            if (b.dfSingleCard) flashQty(b.dfSingleCard, b); else flash(b);
          }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
    wf.dfWrapped = true;
    window.fetch = wf;
  }
  var watchApi = function (b) { pendingApi = b; pendingT = Date.now(); };
  /* Plus/Minus-Zähler der Kachel kurz grün – die App blendet ihn erst nach /cart.js ein, darum kurz darauf warten.
     Sobald er da ist, gibt der (jetzt versteckte) Button seine fixierte Breite wieder frei. */
  var flashQty = function (ac, b) {
    var n = 0;
    var iv = setInterval(function () {
      var q = ac.querySelector('[data-card-quantity-box]');
      if (q) {
        clearInterval(iv);
        if (b) { clearTimeout(b.dfUnlock); unlock(b); }
        q.classList.add('df-added');
        clearTimeout(q.dfT);
        q.dfT = setTimeout(function () { q.classList.remove('df-added'); }, 1200);
      } else if (++n > 60) clearInterval(iv);
    }, 50);
  };
  var flash = function (b) {
    if (!b) return;
    var sp = label(b);
    clearTimeout(b.dfT);
    if (b.dfKeep) b.dfKeep.disconnect();
    if (sp) {
      sp.textContent = L;
      /* solange grün, bleibt "Hinzugefügt" stehen – auch wenn Theme/App den Text zwischendurch zurücksetzen */
      b.dfKeep = new MutationObserver(function () { if (sp.textContent !== L) sp.textContent = L; });
      b.dfKeep.observe(sp, { childList: true, characterData: true, subtree: true });
    }
    b.classList.add('df-added');
    b.dfT = setTimeout(function () {
      if (b.dfKeep) { b.dfKeep.disconnect(); b.dfKeep = null; }
      if (sp && b.dfOrig != null) sp.textContent = b.dfOrig;
      b.classList.remove('df-added');
      unlock(b);
    }, 2000);
  };
  var watch = function () {
    var c = document.querySelector('[data-cart-add-confirmation]');
    if (!c || c.dataset.dfW) return !!c;
    c.dataset.dfW = '1';
    new MutationObserver(function () {
      if (!c.classList.contains('is-visible')) return;
      c.classList.remove('is-visible');
      if (Date.now() - lastT < 15000) flash(last);
    }).observe(c, { attributes: true, attributeFilter: ['class'] });
    return true;
  };
  if (!watch()) { var n = 0; var iv = setInterval(function () { if (watch() || ++n > 30) clearInterval(iv); }, 300); }
})();
